export default __webpack_public_path__ + "static/drzwi-079b367cf9d32a8f6d7c454c0eeca4f1.jpg";